import script from "./PlatformCreateForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlatformCreateForm.vue?vue&type=script&setup=true&lang=ts"

import "./PlatformCreateForm.vue?vue&type=style&index=0&id=595a55a9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-595a55a9"]])

export default __exports__